<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
import { computed, defineAsyncComponent } from "vue";
import { useMounted } from "@vueuse/core";
import VLoader from "@magnit/core/src/components/VLoader/VLoader.vue";
import type { IQRCodeProps } from "./VQRCode.types";

const props = withDefaults(defineProps<IQRCodeProps>(), {
  width: 320,
  height: 320,
  loaderSize: "m",
  loaderColor: "primary",

  value: "",
  fallbackValue: "E0000000000000000T000000",
  margin: 0,
  imgclass: "",
  myclass: "",
  download: false,
  downloadButton: "",
  downloadOptions: { name: "vqr", extension: "png" },
  buttonName: "Download",
  qrOptions: {
    typeNumber: 0,
    mode: "Byte",
    errorCorrectionLevel: "Q",
  },
  imageOptions: { hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
  dotsOptions: {
    type: "dots",
  },
  backgroundOptions: { color: "#ffffff" },
  cornersSquareOptions: { type: "extra-rounded" },
  cornersDotOptions: { type: "dot", color: "#000000" },
  fileExt: "png",
  image: "",
});

const qrComponent = defineAsyncComponent(() => import("qrcode-vue3"));
const qrcodeVal = computed(() => props.value || props.fallbackValue);
const propsToBind = computed(() => {
  const { loaderSize, loaderColor, loading, fallbackValue, ...rest } = props;
  return rest;
});
const isMounted = useMounted();
const qrDimensions = computed(() => ({
  // antialiasing, looks better on high-dpi displays
  width: props.width * 2,
  height: props.height * 2,
}));
const displayQRCode = computed(() =>
  Boolean(isMounted.value && !props.loading && qrcodeVal.value),
);
</script>

<template>
  <div
    class="qr-code"
    :style="{
      width: `${width}px`,
      height: `${height}px`,
    }"
  >
    <component
      :is="qrComponent"
      v-if="displayQRCode"
      v-bind="propsToBind"
      :value="qrcodeVal"
      :width="qrDimensions.width"
      :height="qrDimensions.height"
    />
    <VLoader v-else :color="loaderColor" :size="loaderSize" />
  </div>
</template>

<style lang="postcss" scoped>
.qr-code {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;

  &:deep(img) {
    max-width: 100%;
  }
}
</style>
